import { storePagination, sorting } from '@/mixins'
import axios from '@axios'

const getInitialState = () => ({
  ...storePagination.state(),
  logs: [],
  filters: {
    storeId: null,
    skuId: null,
    status: null,
    transactionId: null,
    createdDateFrom: null,
    createdDateTo: null,
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {},

  mutations: {
    ...storePagination.mutations,

    SET_LOGS(state, logs) {
      state.logs = logs
    },

    SET_FILTERS(state, filters) {
      state.filters = filters
    },

    CLEAN_STATE(state) {
      const { filters, paging, logs } = getInitialState()
      state.filters = filters
      state.paging = paging
      state.logs = logs
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchLogs({ commit, state }) {
      const { data } = await axios.get('/api/skus/price-suggestion-logs', {
        params: {
          storeId: state.filters.storeId,
          skuId: state.filters.skuId,
          status: state.filters.status,
          transactionId: state.filters.transactionId,
          createdDateFrom: state.filters.createdDateFrom,
          createdDateTo: state.filters.createdDateTo,
          pageIndex: state.paging.currentPage - 1,
          pageSize: state.paging.pageSize,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_LOGS', data.results)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount,
        rowsInCurrentPage: data.rowsInCurrentPage,
      })
    },

    resetFilters({ commit }) {
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
